import { ObservationsV1IssueAutonomyLevel } from '@spotify/confidence-graphql';

export const AUTONOMY_LEVEL_OPTIONS: ObservationsV1IssueAutonomyLevel[] = [
  ObservationsV1IssueAutonomyLevel.Collect,
  ObservationsV1IssueAutonomyLevel.Investigate,
  ObservationsV1IssueAutonomyLevel.Build,
  ObservationsV1IssueAutonomyLevel.Full,
];

export const getAutonomyLevelLabel = (
  level: ObservationsV1IssueAutonomyLevel,
): string => {
  switch (level) {
    case ObservationsV1IssueAutonomyLevel.Collect:
      return 'Collect context';
    case ObservationsV1IssueAutonomyLevel.Investigate:
      return 'Investigate and recommend';
    case ObservationsV1IssueAutonomyLevel.Build:
      return 'Build with check-ins';
    case ObservationsV1IssueAutonomyLevel.Full:
      return 'Work autonomously';
    default:
      return level;
  }
};

export const getAutonomyLevelDescription = (
  level: ObservationsV1IssueAutonomyLevel,
): string => {
  switch (level) {
    case ObservationsV1IssueAutonomyLevel.Collect:
      return 'Confidence gathers observations and context, but does not start tasks or make changes.';
    case ObservationsV1IssueAutonomyLevel.Investigate:
      return 'Confidence investigates and recommends next steps, then asks before taking action.';
    case ObservationsV1IssueAutonomyLevel.Build:
      return 'Confidence implements changes and opens pull requests, checking in before major decisions.';
    case ObservationsV1IssueAutonomyLevel.Full:
      return 'Confidence takes the issue from investigation to completion with minimal check-ins.';
    default:
      return '';
  }
};
